<div
  [ngStyle]="{ 'background-color': getBackgroundColor() }"
  class="py-3 px-4 rounded-lg flex items-center text-white w-{{ width() }} h-{{ height() }} shadow-2xl"
>
  <mat-icon [svgIcon]="getIcon()" class="text-[24px] shrink-0"> </mat-icon>
  <p class="text-[16px] font-semibold pl-3 whitespace-pre-wrap">{{ config().message }}</p>
</div>
